import { CSSProperties, memo } from 'react';
import clsx from 'clsx';

import { List } from '@atom/mui';
import iconUtilities from '@atom/utilities/iconUtilities';

import { SubItemContentGroup } from './subItemTreeReducer';

import classes from './subItemTree.module.css';

const { ListItemButton, ListItemText } = List;

const styles = {
  listItemText: {
    marginLeft: '0.625rem',
  },
};

const getRowStyle = (depth: number): CSSProperties => ({
  boxSizing: 'border-box',
  borderLeft: '3px solid transparent',
  paddingLeft: `${depth * 1.5}rem`,
});

type SubItemGroupRowProps = {
  group: SubItemContentGroup;
  depth: number;
  isExpanded: boolean;
  hasDownstreamChanges: boolean;
  onToggle: (key: string) => void;
};

const SubItemGroupRow = ({
  group,
  depth,
  isExpanded,
  hasDownstreamChanges,
  onToggle,
}: SubItemGroupRowProps) => (
  <ListItemButton
    disableGutters
    style={getRowStyle(depth)}
    data-cy={`elementListItem-${group.name}`}
    onClick={() => onToggle(group.key)}
  >
    {iconUtilities.leftIcon(isExpanded ? 'down-arrow' : 'right-arrow')}
    <ListItemText
      primaryTextStyle={styles.listItemText}
      primary={
        <span className={clsx(classes.groupLabel, classes.groupLabelAnchor)}>
          {group.name}
          {hasDownstreamChanges && (
            <div
              className={clsx(classes.changeIndicator, classes.groupIndicator)}
              data-cy={`groupChangeIndicator-${group.name}`}
            />
          )}
        </span>
      }
    />
  </ListItemButton>
);

export default memo(SubItemGroupRow);
